import {
  Button,
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
} from "@fluentui/react-components";
import i18n from "i18next";
import { IAppUserDto } from "../../../Models/IAppUserDto";

interface IMyColleaguesColumns {
  hover: string;
  onSelectMember(member: IAppUserDto): void;
}

export function MyColleaguesColumns(props: IMyColleaguesColumns) {
  const columns: TableColumnDefinition<IAppUserDto>[] = [
    createTableColumn<IAppUserDto>({
      columnId: "Name",
      compare: (a, b) => {
        if (a.fullName && b.fullName) {
          return a.fullName.localeCompare(b.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Name";
      },
      renderCell: (item) => {
        return <div>{item.fullName}</div>;
      },
    }),
    createTableColumn<IAppUserDto>({
      columnId: "Ort",
      compare: (a, b) => {
        if (a.fullName && b.fullName) {
          return a.fullName.localeCompare(b.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Ort";
      },
      renderCell: (item) => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {item.postleitzahl} {item.stadt}
          </div>
        );
      },
    }),
    createTableColumn<IAppUserDto>({
      columnId: "AddButton",
      compare: (a, b) => {
        if (a.fullName && b.fullName) {
          return a.fullName.localeCompare(b.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "";
      },
      renderCell: (item) => {
        return (
          <div>
            <Button
              appearance="primary"
              onClick={() => {
                props.onSelectMember(item);
              }}
            >
              {i18n.t<string>("addMember")}
            </Button>
          </div>
        );
      },
    }),
  ];
  return columns;
}
